<template>
  <div id="app">

    <div id="modal" class="modal is-active" style="z-index:99999;" v-if="!isReady">
  <div class="modal-background"></div>
  <div class="modal-content has-text-centered" style="overflow: visible;width: auto;">
<hollow-dots-spinner
  :animation-duration="1000"
  :dot-size="30"
  :dots-num="4"
  color="white"
/>
  </div>
</div>

    <header>
      <app-header></app-header>
    </header>

    <main>
      <transition name="fade" mode="out-in">
        <router-view :key="$route.fullPath"></router-view>
      </transition>
    </main>
    <footer class="footer">
      <app-footer></app-footer>
    </footer>
  </div>
</template>

<script>
import Header from './components/Header.vue'
import Footer from './components/Footer.vue'
import { HollowDotsSpinner } from 'epic-spinners'
export default {
  components: {
    appHeader: Header,
    appFooter: Footer,
    HollowDotsSpinner
  },
  metaInfo: {
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: 'Jauschneg',
    // all titles will be injected into this template
    titleTemplate: '%s - Planung. Beratung. Forschung.'
  },
  computed: {
    isReady () {
      return this.$store.getters.isReady
    },
    cookie () {
      return this.$store.getters.cookie
    }
  },
  created () {
    this.$store.dispatch('fetchContentFrontend')
    this.$store.dispatch('tryAutoLogin')
  }
}
</script>

<style>
.fade-enter-active, .fade-leave-active {
  transition: opacity .1s ease;
}
.fade-enter, .fade-leave-active {
  opacity: 0
}
.child-view {
  position: absolute;
  transition: all .1s cubic-bezier(.55,0,.1,1);
}
.slide-left-enter, .slide-right-leave-active {
  opacity: 0;
  -webkit-transform: translate(30px, 0);
  transform: translate(30px, 0);
}
.slide-left-leave-active, .slide-right-enter {
  opacity: 0;
  -webkit-transform: translate(-30px, 0);
  transform: translate(-30px, 0);
}
</style>



// WEBPACK FOOTER //
// src/App.vue